import React, { useEffect, useRef, useState } from 'react';
import TimerIcon from '../../Icons/TimerIcon';
import { formatDuration } from '../../../../utils/formatDuration';
import { fetchContact } from '../../../../utils/fetchContact';
import { Typography } from '@coolblue-development/freddy';
import Label from '../../Label';

interface TimerProps {
  contactId: string;
  isAfterCallWork?: boolean;
}

const Timer: React.FC<TimerProps> = ({ contactId, isAfterCallWork }) => {
  const [duration, setDuration] = useState(0);
  const contact = useRef(fetchContact(contactId));

  useEffect(() => {
    if (!contact.current) {
      return;
    }

    setDuration(contact.current.getStateDuration());
  }, [contact]);

  useEffect(() => {
    const timerId = setInterval(() => setDuration(prevDuration => prevDuration + 1000), 1000);
    return () => clearInterval(timerId);
  }, [duration]);

  return (
    <Label data-testid="timer" color={isAfterCallWork ? 'orange' : 'green'} variant="subtle">
      <TimerIcon color={isAfterCallWork ? '#FF6600' : '#008500'} />
      <Typography variant="body" sx={{ marginLeft: '5px' }}>
        {formatDuration(duration)}
      </Typography>
    </Label>
  );
};

export default Timer;
